import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Feroot extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M16.3979919,-2.04565618e-15 C17.5426766,-2.1157479e-15 18.6004089,0.610682026 19.1727513,1.60200808 L23.5707432,9.21955354 C24.1430856,10.2108796 24.1430856,11.4322436 23.5707432,12.4235697 L19.1727513,20.0411152 C18.6004089,21.0324412 17.5426766,21.6431233 16.3979919,21.6431233 L7.60200805,21.6431233 C6.45732335,21.6431233 5.39959105,21.0324412 4.82724867,20.0411152 L0.429256784,12.4235697 C-0.143085595,11.4322436 -0.143085595,10.2108796 0.429256784,9.21955354 L4.82724867,1.60200808 C5.39959105,0.610682026 6.45732335,-1.43696578e-15 7.60200805,-1.5070575e-15 L16.3979919,-2.04565618e-15 Z M15.6983784,7.93794688 L8.30162157,7.93794688 C8.18952054,7.93794688 8.07938076,7.96735462 7.98219968,8.02323375 C7.67539642,8.1996456 7.56969337,8.59136881 7.74610521,8.89817207 L7.74610521,8.89817207 L11.4444836,15.3301345 C11.5009362,15.4283129 11.5823997,15.5097764 11.6805781,15.5662289 C11.9873813,15.7426408 12.3791045,15.6369377 12.5555164,15.3301345 L12.5555164,15.3301345 L16.2538948,8.89817207 C16.3097739,8.80099093 16.3391817,8.6908512 16.3391817,8.57875011 C16.3391817,8.22484429 16.0522843,7.93794688 15.6983784,7.93794688 L15.6983784,7.93794688 Z" />
      </svg>
    );
  }
}

export default Feroot;
